// Leaf module (no React, no DOM): shared by the Sanity schema, the scene host and the choreography.

export const CHANGELOG_SCENE_KEYS = [
  "accounts",
  "trading-journal",
  "daily-diary",
  "strategy",
  "dashboard",
  "morning-brief",
  "session-wrapped",
  "ts-coach",
] as const;

export type ChangelogSceneKey = (typeof CHANGELOG_SCENE_KEYS)[number];

export interface ChangelogSceneConfig {
  title: string;
  /** Element id prefix inside the SVG (`<prefix>__<layer name>`). */
  idPrefix: string;
  width: number;
  height: number;
}

export const CHANGELOG_SCENES: Record<ChangelogSceneKey, ChangelogSceneConfig> = {
  accounts: { title: "Accounts", idPrefix: "img1", width: 704, height: 468 },
  "trading-journal": { title: "Trading Journal", idPrefix: "imgJ", width: 704, height: 468 },
  "daily-diary": { title: "Daily Diary", idPrefix: "img2", width: 704, height: 468 },
  strategy: { title: "Strategy", idPrefix: "img3", width: 704, height: 468 },
  dashboard: { title: "Dashboard", idPrefix: "img4", width: 704, height: 468 },
  "morning-brief": { title: "Morning Brief", idPrefix: "img5", width: 704, height: 468 },
  "session-wrapped": { title: "Session Wrapped", idPrefix: "img6", width: 704, height: 411 },
  "ts-coach": { title: "TS Coach", idPrefix: "img7", width: 704, height: 468 },
};

export function isChangelogSceneKey(value: unknown): value is ChangelogSceneKey {
  return typeof value === "string" && (CHANGELOG_SCENE_KEYS as readonly string[]).includes(value);
}

export function changelogSceneUrl(key: ChangelogSceneKey) {
  return `/changelog/scenes/${key}.svg`;
}
